export default __webpack_public_path__ + "static/media/lds-logo_de.ddbe60b6a1252b54.svg";